export default {
  //Journey
  "Iniciar Questionário": "Empecemos",
  "Confirmar Resposta": "Confirmar respuesta",
  "Próxima Questão": "Próxima pregunta",
  "Respondendo...": "Respondiendo...",

  "Face Sul": "Faz Sur",
  "Face Norte": "Faz Norte",
  "Face Leste": "Faz Leste",
  "Face Oeste": "Faz Oeste",

  // South
  Menos: "Menos",
  "Me Identifico": "Me identifico",
  Mais: "Más",

  // East
  "É importante que você trabalhe sem pressa e responda a todas as afirmações sinceramente.":
    "Es importante que responda las preguntas con paciencia y sinceridad.",
  "Absolutamente não me identifico com a frase":
    "No me identifico absolutamente con la frase.",
  "Descreve-me perfeitamente": "Me describe perfectamente",
  "Você precisa preencher toda as questões!":
    "¡Tienes que responder todas las preguntas!",

  // West
  "pontos distribuídos": "puntos distribuidos",
  "Você precisa distribuir todos os": "Necesitas distribuir todo el",
  pontos: "puntos",

  // Complete
  Parabéns: "Felicidades",
  "Você concluiu com sucesso o questionário!":
    "¡Has completado con éxito el cuestionario!",
  "Fazer Download do Relatório": "Descargar Informe",
  "Quando disponível, você receberá um e-mail com o link para baixar seu relatório.":
    "Cuando esté disponible, recibirá un correo electrónico con el enlace para descargar el informe."
};



// WEBPACK FOOTER //
// ./src/translations/es.js